export default "__VITE_ASSET__DpIbHkgm__"